/**
 * ID del Box scrollable de la vista de edición de BORRADOR V2.
 *
 * Consumido por:
 *  - `EditarPropuestaV2/index.js` — lo asigna al Box que contiene las secciones.
 *  - `NavLateralEdicion.js` — lo busca con `document.getElementById` y lo usa
 *    como `root` del `IntersectionObserver` para el scroll-spy.
 *
 * Si este id cambia, actualizar ambos archivos.
 */
export const SCROLL_CONTAINER_ID = "editar-propuesta-v2-scroll";
